const authTypes = {
	NONE: "none",
	OAUTH: "oauth",
};

export default authTypes;
